import { useEffect, useState } from "react";
import { Building2, Loader2 } from "lucide-react";
import { api } from "@/lib/leuteliaApi";

const euro = (n) => `${(n || 0).toLocaleString("it-IT")} €`;
const SCANS = [1, 2, 3, 4];

export default function ConfiguratoreCollection() {
  const [hotels, setHotels] = useState([{ name: "", scans: 2 }, { name: "", scans: 2 }, { name: "", scans: 2 }]);
  const [quote, setQuote] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let alive = true;
    setBusy(true);
    api.adminCollectionQuote({ hotels }).then((q) => { if (alive) { setQuote(q); setErr(null); } }).catch((e) => { if (alive) { setErr(e.message); setQuote(null); } }).finally(() => alive && setBusy(false));
    return () => { alive = false; };
  }, [hotels]);
  const setN = (n) => setHotels((h) => (n > h.length ? [...h, ...Array.from({ length: n - h.length }, () => ({ name: "", scans: 2 }))] : h.slice(0, n)));
  const upd = (i, patch) => setHotels((h) => h.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  return (
    <div className="bg-white rounded-xl border border-brand-gold/25 p-5" data-testid="configuratore-collection">
      <div className="flex items-start gap-3">
        <Building2 size={18} className="text-brand-gold mt-0.5" />
        <div>
          <h3 className="font-serif text-[20px] text-brand-ink leading-none">Preventivo COLLECTION</h3>
          <p className="text-[12.5px] text-brand-ink/60 mt-1.5">Gruppi da 3 a 8 hotel. Il prezzo di ogni hotel dipende dal numero di strutture e dalle scansioni mensili scelte per quella struttura. Prezzi mensili IVA esclusa; il setup è una tantum e separato.</p>
        </div>
      </div>
      <label className="mt-4 block text-[11.5px] text-brand-muted">Numero di hotel nel gruppo
        <select className="ml-2 rounded-md border border-brand-gold/30 bg-white px-2 py-1 text-[12.5px]" value={hotels.length} onChange={(e) => setN(Number(e.target.value))} data-testid="collection-n-hotel">
          {[3, 4, 5, 6, 7, 8].map((n) => <option key={n} value={n}>{n} hotel</option>)}
        </select>
      </label>
      <div className="mt-3 space-y-1.5">
        {hotels.map((h, i) => (
          <div key={i} className="grid grid-cols-[1fr_auto_110px] items-center gap-2" data-testid={`collection-hotel-${i}`}>
            <input value={h.name} onChange={(e) => upd(i, { name: e.target.value })} placeholder={`Hotel ${i + 1}`} className="h-8 rounded-md border border-brand-gold/30 px-2 text-[12.5px]" data-testid={`collection-hotel-nome-${i}`} />
            <select value={h.scans} onChange={(e) => upd(i, { scans: Number(e.target.value) })} className="h-8 rounded-md border border-brand-gold/30 bg-white px-2 text-[12.5px]" data-testid={`collection-hotel-scansioni-${i}`}>
              {SCANS.map((s) => <option key={s} value={s}>{s} scansion{s === 1 ? "e" : "i"}/mese</option>)}
            </select>
            <div className="text-right text-[13px] font-semibold text-brand-ink" data-testid={`collection-hotel-prezzo-${i}`}>{quote?.rows?.[i] ? `${euro(quote.rows[i].price)}/mese` : "—"}</div>
          </div>
        ))}
      </div>
      {err && <div className="mt-3 text-[12.5px] text-brand-maroon" data-testid="collection-errore">{err}</div>}
      {quote && (
        <div className="mt-4 grid gap-x-6 gap-y-2 sm:grid-cols-2 rounded-lg border border-brand-gold/25 bg-brand-cream/50 p-4 text-[13px]" data-testid="collection-riepilogo">
          <div className="flex justify-between"><span className="text-brand-ink/70">Canone mensile del gruppo</span><b data-testid="collection-totale-mensile">{euro(quote.monthly_total)}</b></div>
          <div className="flex justify-between"><span className="text-brand-ink/70">Scansioni complete al mese</span><b data-testid="collection-scansioni-totali">{quote.scans_total}</b></div>
          <div className="flex justify-between"><span className="text-brand-ink/70">Setup una tantum (290 € + 270 € per hotel aggiuntivo)</span><b data-testid="collection-setup-totale">{euro(quote.setup_total)}</b></div>
          <div className="flex justify-between"><span className="text-brand-ink/70">Totale primo periodo (setup + primo canone)</span><b data-testid="collection-primo-periodo">{euro(quote.first_period_total)}</b></div>
        </div>
      )}
      {busy && <div className="mt-2 flex items-center gap-1.5 text-[11.5px] text-brand-muted"><Loader2 size={12} className="animate-spin" /> calcolo…</div>}
    </div>
  );
}
